import React from "react";

import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";
import { useCustomer } from "@app/contexts/CustomerContext";
import { useDossier, useDossierDispatch, DOSSIER_ACTIONS } from "@app/contexts/DossierContext";
import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { Plus } from "lucide-react";
import { initStructureObject, buildStructureFormDataBuilder } from "@app/utils/form_data_builders/StructureFormDataBuilder";

export default function DossierAddPDL() {
    const customer = useCustomer();    
    const dossier = useDossier();
    const dossierDispatch = useDossierDispatch();

    const auth = useAuth();
    
    function reloadDossier() {
        apiCall ({
            method: "get",
            path: `/api/v1/dossiers/${dossier.id}`,
            auth: auth,
            onSuccess: (response) => {
                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,
                    payload: response.data.dossier
                });
            }
        });
    }

    /**
     * Add a new structure with a new structure_data 
     * @param {*} event 
     */
    function addNewPDL(event) {
        event.preventDefault();

        let structure = initStructureObject();
        
        structure.customer_id = customer.id;
        structure.trade_name = `Site ${dossier.structure_datas ? dossier.structure_datas?.length + 1 : 1}`

        const formData = buildStructureFormDataBuilder(structure);
        
        formData.append('structure[structure_datas_attributes][][dossier_id]', dossier.id);

        apiCall({
            method: "post",
            path: `/api/v1/structures`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                reloadDossier();
            }
        });
    }

    return (
        <div className="text-end">
            <ButtonSecondary label="Ajouter un site" onClick={addNewPDL} icon={<Plus />} />
        </div>        
    )
}